<template>
  <scroll-center-dialog v-model="opened" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <v-card-text>
      <loading-autocomplete
          placeholder="Введите ФИО и выберете из предложенных вариантов"
          label="Сотрудник"
          v-model="value.user"
          search-parameter="fio"
          :post-loader="postLoader"
          :url="department_selector"
          outlined
          :error="hasError('user')"
          :errorMessages="getError('user')"
      >
        <template v-slot:no-data>
          <div>
            Для поиска начните набирать ФИО, <br> и либо остановитесь на 1 секунду, либо нажмите Enter
          </div>
        </template>
      </loading-autocomplete>
      <v-autocomplete
          :error="hasError('event')"
          :error-messages="getError('event')"
          :items="selectors.event"
          label="Доступ к событию"
          no-data-text="Нет данных"
          v-model="value.event"
          outlined
          item-value="id"
          item-text="name"
      ></v-autocomplete>

    </v-card-text>
  </scroll-center-dialog>
</template>

<script>
import urls from '@/urls/helper.js'
import {makeGetRequest, makePostRequest} from "@/helper/requests";
import {generateListUidToName} from "@/helper/uidToName";
import selectors from "@/urls/selectors";
import LoadingAutocomplete from "@/modules/templates/LoadingAutocomplete.vue";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog.vue";
import FormErrorsMixin from "@/mixins/FormErrorsMixin";
import {mapActions} from "vuex";

export default {
  name: "Role",
  mixins: [FormErrorsMixin],
  components: {LoadingAutocomplete, ScrollCenterDialog},
  props: {
    opened: Boolean,
    edit: Boolean,
    docs_data: Object,
    user: Object,
    id: Number,
    event: Number,
  },
  data() {
    return {
      value: {
        id: this.id || '',
        user: this.user || '',
        event: this.event || null,
      },
      selectors: {
        event: [],
      },
    }
  },
  computed: {
    department_selector() {
      return selectors.SELECTORS.WORKER.ALL()
    },
    form_title() {
      return 'Добавить'
    },
  },
  methods: {
    ...mapActions({
      createData: 'permission/createRole',
    }),
    save() {
      this.createData({
        data: this.value,
        finalizer: (val) => {
          this.$emit('close', true)
        },
        catcher: (val) => {
          this.mapErrors(val)
        },
      })
    },
    close() {
      this.$emit('close', false)
    },
    postLoader(data, list, end) {
      data.results.forEach(el => {
        this.$set(el, 'fio', '');
      })
      let vals = list(data.results);
      generateListUidToName(
          vals,
          "value",
          "fio",
          () => {
            vals.forEach(el => {
              this.$set(el, 'text', `${el.fio}, ${el.text}`)
            })
            end();
          }
      )
    },
    loadSelector() {
      let url = urls.getRecordingUrlWithParameters('admin|events-list', 'list')
      let sys = true
      makeGetRequest(url).then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }).then(json => {
        this.selectors.event = json.results
      })
    },
  },
  created() {
    // this.loaders.responsible.handler();
    this.loadSelector();
  }
}
</script>

<style scoped>
</style>
